import { languageSelector } from "@/src/contexts";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, type PropsWithStyleX, colors } from "../../../styles/tokens.stylex";
import Resources from "./PriceComparisonItem.Resources";
import ResourcesEn from "./PriceComparisonItem.Resources.En";

type IPriceComparisonItemPrice = PropsWithStyleX & {
    variant: keyof typeof priceStyles;
    amount: string;
    isMobile: boolean;
};

export default function PriceComparisonItemPrice(props: IPriceComparisonItemPrice) {
    const resources = languageSelector(Resources, ResourcesEn);

    const labelStyle = labelStyles[props.variant];
    const priceStyle = props.isMobile ? priceStylesMobile[props.variant] : priceStyles[props.variant];

    return (
        <div {...stylex.props(styles.default, props.styleX)}>
            <span {...stylex.props(labelStyle)}>{resources.pcItemPriceText}</span>
            <h5 {...stylex.props(styles.price, priceStyle)}>
                <b>{props.amount}</b>
            </h5>
        </div>
    );
}

const styles = stylex.create({
    default: {
        fontSize: "1rem",
    },
    price: {
        color: colors.fg_BrandNavy,
        display: "inline",
        paddingLeft: ComposableSpacing.s1,
    },
});

const priceStyles = stylex.create({
    searchResultsDetails: {
        fontSize: "1.25em",
        lineHeight: 1.4,
    },
});

const priceStylesMobile = stylex.create({
    searchResultsDetails: {
        fontSize: "1.125em",
        lineHeight: 1.44,
    },
});

const labelStyles = stylex.create({
    searchResultsDetails: {
        fontSize: "1em",
        lineHeight: 1.5,
    },
});
